import React from "react";
import { ValueTableRuleBuilder } from "../ValueTableRuleBuilder";
import { getEmptyValueTable, getValueTableWithDeferentType } from "../Testing/TestDataSetup";
import { getFilledDataDefinition } from "../../../../rule-engine-core/Common/Data/DataTestData";
import { StoryNode } from "../../../../CommonUI/StoryBook/StoryData";

export const ValueTableStories = [
    new StoryNode(
        () => {
            let ruleDefinition = getEmptyValueTable();

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Empty",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableWithDeferentType(true);

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Different Type",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableWithDeferentType(false);
            ruleDefinition.executionResult = getFilledDataDefinition();

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Writable Outputs",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableWithDeferentType(true);
            ruleDefinition.rows[0].cells[0].values = "This is a long value for test.";

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Long Value",
    ),
];
